import { Typography } from "@mui/material";

export function RequiredField() {
  return (
    <Typography fontSize="18px" component="span" color="error700.main">
      *
    </Typography>
  );
}
